import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import { returnUserStatusAdminContext } from "../../../context/Admin/ReturnUserStatusAdminContext/ReturnUserStatusAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const ReturnUserStatusAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    returnUserStatusItems,
    description,
    setDescription,
    isShowModal,
    handleShowModal,
    handleCloseModal,
    handleGetReturnUserStatusItemList,
    handleCreateReturnUserStatusItem,
    handleDeleteReturnUserStatusItem,
  } = useContext(returnUserStatusAdminContext);

  useEffect(() => {
    handleGetReturnUserStatusItemList();
  }, []);

  return (
    <>
      <SiteTitle title="دلایل کنسلی" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "دلایل لغو", type: "a" },
        ]}
        title="دلایل کنسلی"
      />

      <CardLayout>
        {permission.return_user_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(returnUserStatusItems) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>توضیحات</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {returnUserStatusItems.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.id}</td>
                  <td>{_item.description}</td>
                  <td className="mw-25">
                    {permission.return_user_destroy && (
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteReturnUserStatusItem(_item.id),
                            `آیا از حذف دلیل ${_item.id} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title="افزودن دلیل کنسلی"
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form onSubmit={handleCreateReturnUserStatusItem} autoComplete="off">
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2"></i>
            افزودن
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default ReturnUserStatusAdmin;
